import axios from "../plugins/axios";
export default {
  state: {
    advertisement: {
      data: {},
      error: [],
      form: {},
    },
    loading: false,
  },
  mutations: {
    setForm(state, data) {
      state.advertisement.form = data;
    },
    setData(state, data) {
      state.advertisement.data = data;
    },
    setErrors(state, data) {
      state.advertisement.error = data;
    },
    setLoading(state, set) {
      state.loading = set;
    },
  },
  actions: {
    async getAdvertisement({ commit }) {
      commit("setLoading", true);
      try {
        let response = await axios.get("/api/advertisement", {
          headers: { Authorization: "Bearer " + localStorage.getItem("token") },
        });
        if (response.status == 200) {
          commit("setData", response.data.advertisement);
          commit("setLoading", false);
        }
      } catch (errors) {
        commit("setErrors", errors.response.data.errors);
        commit("setLoading", false);
      }
    },
    async postAdvertisement({ commit }, data) {
      commit("setLoading", true);
      try {
        let response = await axios.post("/api/advertisement/upload", data, {
          headers: { Authorization: "Bearer " + localStorage.getItem("token") },
        });
        if (response.status == 200) {
          commit("setData", response.data.advertisement);
          commit("setLoading", false);
          commit("setForm", {});
          commit("setErrors", {});
          alert("Iklan berhasil disimpan");
        }
      } catch (errors) {
        commit("setErrors", errors.response.data.errors);
        commit("setLoading", false);
      }
    },
  },
};
